import { Link } from "react-router-dom";
import { LuCheck, LuMail, LuShieldAlert, LuTicket } from "react-icons/lu";

const PaymentApproved = () => {
    return (
        <main className="relative overflow-hidden bg-zinc-950 text-white">
            <section className="relative isolate overflow-hidden pb-16 pt-28 sm:pt-32 lg:pt-36">
                <div
                    className="pointer-events-none absolute inset-0 opacity-80"
                    aria-hidden="true"
                    style={{
                        background:
                            "radial-gradient(circle at 15% 20%, rgba(244, 63, 94, 0.22), transparent 34%), radial-gradient(circle at 85% 15%, rgba(225, 29, 72, 0.14), transparent 28%), radial-gradient(circle at 50% 85%, rgba(250, 204, 21, 0.08), transparent 36%)",
                    }}
                />

                <div className="relative mx-auto flex min-h-[70vh] w-full max-w-6xl items-center justify-center px-4 sm:px-6">
                    <div className="w-full max-w-2xl rounded-[2rem] border border-zinc-800 bg-zinc-900/75 p-6 shadow-[0_24px_70px_rgba(0,0,0,0.42)] backdrop-blur-sm sm:p-8">
                        <div className="flex items-center gap-3">
                            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-rose-500/15 text-rose-300">
                                <LuCheck className="text-2xl" />
                            </div>
                            <div>
                                <p className="text-xs font-semibold uppercase tracking-[0.28em] text-rose-300/80">
                                    Pago aprobado
                                </p>
                                <h1 className="mt-2 text-3xl font-black leading-tight text-white sm:text-4xl">
                                    Ya casi está, revisá tu correo
                                </h1>
                            </div>
                        </div>

                        <p className="mt-5 max-w-xl text-base leading-7 text-zinc-200 sm:text-lg">
                            Si tu pago fue aprobado o la compra fue gratuita, tus entradas
                            llegarán al mail con el que hiciste la compra.
                        </p>

                        <div className="mt-6 grid gap-3 sm:grid-cols-2">
                            <div className="rounded-2xl border border-zinc-800 bg-zinc-950/60 p-4">
                                <div className="flex items-center gap-3">
                                    <LuMail className="text-xl text-rose-300" />
                                    <span className="font-semibold text-white">Revisá tu correo</span>
                                </div>
                                <p className="mt-2 text-sm leading-6 text-zinc-300">
                                    Buscá el mail de confirmación y no olvides mirar la carpeta de spam
                                    o correo no deseado.
                                </p>
                            </div>

                            <div className="rounded-2xl border border-zinc-800 bg-zinc-950/60 p-4">
                                <div className="flex items-center gap-3">
                                    <LuTicket className="text-xl text-rose-300" />
                                    <span className="font-semibold text-white">Tus tickets</span>
                                </div>
                                <p className="mt-2 text-sm leading-6 text-zinc-300">
                                    También podés revisarlos desde la sección <span className="font-semibold text-zinc-100">Mis tickets</span>.
                                </p>
                            </div>
                        </div>

                        <div className="mt-6 rounded-2xl border border-amber-500/20 bg-amber-500/10 p-4">
                            <div className="flex items-start gap-3">
                                <LuShieldAlert className="mt-0.5 text-xl text-amber-200" />
                                <p className="text-sm leading-6 text-amber-50">
                                    Consejo: si no ves el mail en pocos minutos, revisá también spam y correo no deseado.
                                </p>
                            </div>
                        </div>

                        <div className="mt-7 flex flex-col gap-3 sm:flex-row justify-center">
                            <Link
                                to="/tickets"
                                className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-rose-500 to-rose-600 px-5 py-3 font-semibold text-white shadow-[0_10px_20px_rgba(244,63,94,0.25)] transition hover:scale-[1.01] hover:from-rose-400 hover:to-rose-500"
                            >
                                Ir a Mis tickets
                            </Link>
                            <Link
                                to="/"
                                className="inline-flex items-center justify-center rounded-xl border border-zinc-700 bg-zinc-900/70 px-5 py-3 font-semibold text-zinc-100 transition-colors hover:border-zinc-500 hover:bg-zinc-800"
                            >
                                Seguir explorando
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default PaymentApproved;
